import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IRoomserviceState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const administrationModule: Module<IRoomserviceState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default administrationModule
